import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import BoxSection from '../components/Layout/BoxSection'
import SelectorInput from '../components/Shared/SelectorInput'
import ModalSelectorFromList from '../components/Shared/ModalSelectorFromList'
import AttachedFilesBox from '../components/Shared/AttachedFilesBox'



import { showModalSelector, selectFromSelector } from '../actions/common'


import {
    updateInputs,
    createContratoAnual
} from '../actions/creacioncontratoanual'

class CreacionContratoAnual extends Component {


    handleOpenSelectorProveedor = (list) => {

        let columns = [
            { id: 1, caption: 'Nit', value: 'identificacion', width: '30%' },
            { id: 2, caption: 'Razon Social', value: 'nombre', width: '70%' }   
        ]

        const payload = {}

        const fn = (a) => {
            payload.path = list
            payload.value = a;
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL', payload);
        }

        this.props.showModalSelector('Listado de proveedores', columns, `/proveedores`, fn)
    }


	render() {

        const { creacioncontratoanual, enums } = this.props


        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.createContratoAnual() } title="Guardar" disabled={ creacioncontratoanual.get('btnSaveDisabled') } />
        ]


		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Solicitud de contrato anual > Creación">
                        <ButtonStrip actions={ boxActions } />
                        <div className="box-content">
                            <div>
                                <BoxSection title="Información básica">

                                <div className="row">

                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <label className="control-label">Solicitante</label>
                                                <input type="text" value={this.props.user.get('fullname') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input type="text" value={this.props.user.get('email') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input type="text" value={this.props.user.get('extension') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Área</label>
                                                <input type="text" value={this.props.user.getIn(['area', 'nombre']) || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                    </div>


                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <label className="control-label">Responsable de compras</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creacioncontratoanual.get('tipo')].responsable.fullname || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input className="form-control input-sm" value={enums.solicitudes.tipos[creacioncontratoanual.get('tipo')].responsable.email || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creacioncontratoanual.get('tipo')].responsable.extension || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Fecha de solicitud</label>
                                                <input className="form-control input-sm" value={moment().format('YYYY/MM/DD')} disabled />
                                            </div>
                                        </div>

                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Datos del contrato">

                                <div className="row">

                                        <div className="col-md-8">
                                            <div className="form-group">
                                                <label className="control-label">Tipo de servicio a desarrollar</label>
                                                <input type="text" value={ creacioncontratoanual.get('proyecto_evento') || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('proyecto_evento', e.target.value) }/>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Inicio del contrato</label>
                                                <input className="form-control input-sm" type="date" value={ creacioncontratoanual.get('fecha_inicio') || '' }  onChange={ e => this.props.updateInputs('fecha_inicio', e.target.value) }/>
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Terminación del contrato</label>
                                                <input type="date" value={ creacioncontratoanual.get('fecha_entrega') || '' } className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                    </div>                                    

                                </BoxSection>

                                <div className="separator"></div>


                                <BoxSection title="Datos del proveedor/contratista">

                                    <div className="row">


                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="control-label">Nombre de razón social</label>
                                                <SelectorInput 
                                                value={ creacioncontratoanual.get('proveedor') ? creacioncontratoanual.getIn(['proveedor', 'nombre']) : '' } 
                                                onClick={ () => this.handleOpenSelectorProveedor('proveedor') } 
                                                onReset={ () => this.props.updateInputs('proveedor', null) } 
                                                 />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Nit</label>
                                                <input type="text" value={ creacioncontratoanual.getIn(['proveedor', 'identificacion']) || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('proveedor.identificacion', e.target.value) } />
                                            </div>
                                        </div>                                        

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="control-label">Nombre del representante legal</label>
                                                <input type="text" value={ creacioncontratoanual.getIn(['proveedor', 'representante']) || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('proveedor.representante', e.target.value) } />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">C.C. del representante legal</label>
                                                <input type="text" value={ creacioncontratoanual.getIn(['proveedor', 'cc_representante']) || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('proveedor.cc_representante', e.target.value) }/>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Persona de contacto</label>
                                                <input type="text" value={ creacioncontratoanual.getIn(['proveedor', 'contacto']) || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('proveedor.contacto', e.target.value) } />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Cargo</label>
                                                <input type="text" value={ creacioncontratoanual.getIn(['proveedor', 'cargo']) || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('proveedor.cargo', e.target.value) }/>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo electrónico</label>
                                                <input type="text" value={ creacioncontratoanual.getIn(['proveedor', 'correo']) || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('proveedor.correo', e.target.value) }/>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Celular/Teléfono</label>
                                                <input type="text" value={ creacioncontratoanual.getIn(['proveedor', 'telefono']) || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('proveedor.telefono', e.target.value) }/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="control-label">Dirección para envío de notificaciones</label>
                                                <input type="text" value={ creacioncontratoanual.getIn(['proveedor', 'direccion']) || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('proveedor.direccion', e.target.value) }/>
                                            </div>
                                        </div>
                                    </div>

                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Observaciones">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <textarea type="text" className="form-control input-sm" rows={4} value={ creacioncontratoanual.get('observaciones') || '' } onChange={ (e) => this.props.updateInputs('observaciones', e.target.value) } />
                                            </div>
                                        </div>
                                    </div>                                
                                </BoxSection>

                                <div className="separator"></div>

                                <AttachedFilesBox
                                    files={ creacioncontratoanual.get('adjuntos') }
                                    updateInputs = { this.props.updateInputs }
                                    obj={ creacioncontratoanual }
                                    check={ 'solicitud' }
                                    disabledAttach
                                />

                            </div>
                        </div>
                    </Box>
                </div>

                <ModalSelectorFromList />

            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        user: state.common.get('user'),
        creacioncontratoanual: state.creacioncontratoanual,
        enums: state.common.get('enums').toJS(),        
        responsable: state.common.getIn(['parametros', 'SOLICITUDES']) ? state.common.getIn(['parametros', 'SOLICITUDES']).filter(x => x.get('TIPO_SOLICITUD') == state.creacionsolicitudhoteles.get('tipo')).first() : null
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        createContratoAnual: () => dispatch(createContratoAnual()),
        showModalSelector: (title, fields, url, action) => dispatch(showModalSelector(title, fields, url, action)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreacionContratoAnual)


// WEBPACK FOOTER //
// ./src/containers/CreacionContratoAnual.jsx